import { render, staticRenderFns } from "./EllipsisMenu.vue?vue&type=template&id=6ecce506&scoped=true&"
import script from "./EllipsisMenu.vue?vue&type=script&lang=js&"
export * from "./EllipsisMenu.vue?vue&type=script&lang=js&"
import style0 from "./EllipsisMenu.vue?vue&type=style&index=0&id=6ecce506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecce506",
  null
  
)

export default component.exports